// removed by extract-text-webpack-plugin
module.exports = {"entries":"src-pages----schedule-module---entries---2vE_5 grid grid_6cols","entryTime":"src-pages----schedule-module---entryTime---3trIO grid--1col","entryDescription":"src-pages----schedule-module---entryDescription---3WZXx grid--5col","talkTime":"src-pages----schedule-module---talkTime---1-mcP src-pages----schedule-module---entryTime---3trIO grid--1col","talkDescription":"src-pages----schedule-module---talkDescription---1OVlg src-pages----schedule-module---entryDescription---3WZXx grid--5col","talkTitle":"src-pages----schedule-module---talkTitle---mYGuS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/schedule.module.scss
// module id = 456
// module chunks = 53569954864128